import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import moment from 'moment';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { showMainLoader } from '@webapp/store/ui/selectors';

// Components
import Box from '@components/layout/box';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import BoxTitleHeader from '@components/layout/box-title-header';
import SubscriptionItemComponent from '@webapp/controllers/subscription/subscription-item';

import PaymentInput from './payment-input';

import { EntitySubscription } from '@common/types/subscription-manager/list-subscriptions-response';
import AppState from '@webapp/store/state';
import { SimplePaymentMethod } from '@services/payment/types/simple-payment-method';
import { RemovePaymentMethod } from '@webapp/store/payment/action-creators';
import { useLocation } from 'react-router';
import SuccessSubscriptionMenu from '@components/success-subscription-menu';
import { isMobile } from '@components/styles';
import { Product } from '@services/product/types/product';
import { getTracProPlan } from '../../../store/products/selectors';

interface ArtistSubscriptionsProps {
  className?: string;
  artistSubs?: EntitySubscription;
  cardList: SimplePaymentMethod[];
  clientId: string;
  loading: boolean;
  removePaymentMethod: (
    clientId: string,
    paymentMethodId: string
  ) => RemovePaymentMethod;
  tracPro: Product;
}

const mapStateToProps = (state: AppState) => {
  const clientId = state.artist.active?.id as string;
  return {
    clientId,
    artistSubs: clientId
      ? state.subscriptionManager.summary?.artists.find(
          (a) => a.id === clientId
        )
      : undefined,
    cardList: clientId ? state.payment.methods[clientId] : undefined,
    loading: showMainLoader(state),
    tracPro: getTracProPlan(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  removePaymentMethod: (clientId: string, paymentMethodId: string) =>
    dispatch(new RemovePaymentMethod(clientId, paymentMethodId)),
});

export const ArtistSubscriptions: React.FC<ArtistSubscriptionsProps> = (
  props
) => {
  const urlParams = new URLSearchParams(useLocation().search);
  const type = urlParams.get('success');

  const getText = (
    isActive: boolean,
    isExpiring: boolean,
    endsAt: string,
    nextBilling: string,
    trial_ends?: string
  ) => {
    if (!isActive) {
      return <Translate id="USER_PROFILE.SUBSCRIPTION.EXPIRED" />;
    }
    if (trial_ends) {
      const trialEndsDate = moment(trial_ends).startOf('day');

      if (trialEndsDate.isSameOrAfter(moment().startOf('day'))) {
        return (
          <>
            {isExpiring ? (
              <Translate id="USER_PROFILE.SUBSCRIPTION.EXPIRING_ON" />
            ) : (
              <Translate id="USER_PROFILE.SUBSCRIPTION.TRIAL_ENDS" />
            )}{' '}
            {trialEndsDate.format('LL')}
          </>
        );
      }
    }
    if (isExpiring) {
      return (
        <>
          <Translate id="USER_PROFILE.SUBSCRIPTION.EXPIRING_ON" />{' '}
          {moment(endsAt).format('LL')}
        </>
      );
    }

    return (
      <>
        <Translate id="USER_PROFILE.SUBSCRIPTION.NEXT_BILL" />{' '}
        {moment(nextBilling).format('LL')}
      </>
    );
  };

  // TODO: DEVTEAM-845 - Integrate handlePaymentChange
  // const handlePaymentChange = (value: PaymentType) => {
  //   setSelectedPayment(value);
  // };

  const handleRemoveCard = (paymentMethodId: string) => {
    if (props.clientId) {
      props.removePaymentMethod(props.clientId, paymentMethodId);
    }

    return;
  };

  // TODO: DEVTEAM-845 - Integrate handleRemovePaypal
  // const handleRemovePaypal = () => {
  //   return;
  // };

  // TODO: DEVTEAM-845 - Integrate handleRemoveTracWallet
  // const handleRemoveTracWallet = () => {
  //   return;
  // };

  // const goToInvoices = () => {
  //   // TODO: DEVTEAM-845 - Integrate artist id
  //   dispatch(push('/subscriptions/invoices'));
  // };

  return (
    <MotionOpacity className={props.className}>
      {!isMobile ? (
        <Typography
          className="mb-20"
          type="subheader"
          weight="400"
          customFont="semi-bold"
        >
          <Translate id="ARTIST_PROFILE.SUBSCRIPTION.TITLE" />
        </Typography>
      ) : null}
      <SectionWrapper>
        <Box noBorderBottom>
          <SubscriptionsWrapper>
            {props.artistSubs?.subscriptions
              .filter(
                (i) =>
                  i.isActive &&
                  !['beginner', 'basic'].includes(i.plan.toLowerCase())
              )
              .map((item) => (
                <SubscriptionItemComponent
                  key={`${item.type}-${item.id}`}
                  id={item.id}
                  isActive={item.isActive && item.plan !== 'Beginner'}
                  frequency={item.subscription.frequency}
                  price={
                    item.subscription?.price?.value
                      ? item.subscription?.price?.value / 100
                      : item.invoices[0]
                      ? item.invoices[0].amount
                      : undefined
                  }
                  type={item.type}
                  plan={item.type !== 'merch' ? item.plan : ''}
                  text={getText(
                    item.isActive,
                    item.isExpiring,
                    item.endsAt || '',
                    item.nextBilling || '',
                    item.subscription.trial_ends
                  )}
                  artistId={props.clientId}
                  isExpiring={item.isExpiring}
                />
              ))}
            {props.tracPro &&
            !props.artistSubs?.subscriptions.some(
              (i) =>
                i.isActive &&
                !['beginner', 'basic'].includes(i.plan.toLowerCase())
            ) ? (
              <SubscriptionItemComponent
                id={props.tracPro?.id}
                isActive={false}
                price={props.tracPro?.prices}
                type={'trac-pro'}
                plan={'trac Pro'}
                artistId={props.clientId}
                isExpiring={false}
              />
            ) : null}
          </SubscriptionsWrapper>
        </Box>
        <Box noBorderTop>
          <BoxTitleHeader
            title={<Translate id="ARTIST_PROFILE.SUBSCRIPTION.BILLING.TITLE" />}
            className="mb-20"
          />
          <BillingWrapper>
            {/* TODO: DEVTEAM-845 - Integrate new billing input */}
            {/*<BillingInput*/}
            {/*  // TODO: DEVTEAM-845 - Integrate errors (just an example below)*/}
            {/*  // error={'Already in use'}*/}
            {/*  payment={selectedPayment as PaymentType}*/}
            {/*  onPaymentChange={handlePaymentChange}*/}
            {/*  onChange={(value) => setSelectedPayment(value)}*/}
            {/*/>*/}
            {/* TODO: DEVTEAM-845 - Integrate credit card if the user has one. */}
            {props?.cardList?.map((method) => (
              <PaymentInput
                key={method.id}
                value={method.last4}
                onClick={() => handleRemoveCard(method.id)}
                brand={method.brand}
                paymentType={method.type}
              />
            ))}
            {/* TODO: DEVTEAM-845 - Integrate paypal if the user has it. */}
            {/*<PaymentInput*/}
            {/*  value={'user@trac.com'}*/}
            {/*  onClick={handleRemovePaypal}*/}
            {/*  paymentType="pay-pal"*/}
            {/*  // TODO: DEVTEAM-845 - Integrate charges that is being paid with it (It could be on any payment method).*/}
            {/*  hasCharges="Distribution, Merch"*/}
            {/*/>*/}
            {/* TODO: DEVTEAM-845 - Integrate tracWallet if the user has it. */}
            {/*<PaymentInput*/}
            {/*  value={'Legal Name'}*/}
            {/*  onClick={handleRemoveTracWallet}*/}
            {/*  paymentType="trac-wallet"*/}
            {/*/>*/}
          </BillingWrapper>
          {/*<Link className="mt-20" onClick={goToInvoices}>*/}
          {/*  <Translate id="USER_PROFILE.SUBSCRIPTION.INVOICES.SEE_ALL" />*/}
          {/*</Link>*/}
        </Box>
      </SectionWrapper>
      {type && <SuccessSubscriptionMenu type={type} />}
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ArtistSubscriptions)``);

const SectionWrapper = styled.div`
  display: grid;
  gap: 3px;
  margin-bottom: 80px;
`;

const SubscriptionsWrapper = styled.div`
  display: grid;
  gap: 10px;
`;

const BillingWrapper = styled.div`
  display: grid;
  gap: 10px;
`;

// const Link = styled(Typography)`
//   cursor: pointer;
//   font-weight: 700;
//   transition: opacity
//     ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
//
//   &:hover {
//     opacity: 0.5;
//   }
// `;
